var map = {
	"./female/eyes-color/black.svg": "6a43",
	"./female/eyes-color/blue.svg": "110a",
	"./female/eyes-color/brown.svg": "56a1",
	"./female/eyes-color/green.svg": "96cb",
	"./female/eyes-color/grey.svg": "169e",
	"./female/eyes-color/hazel.svg": "dc4e",
	"./female/head-hair-color/black.svg": "97f0",
	"./female/head-hair-color/dark_blonde.svg": "d925a",
	"./female/head-hair-color/dark_brown.svg": "647d",
	"./female/head-hair-color/light_blonde.svg": "281d",
	"./female/head-hair-color/light_brown.svg": "a7b6",
	"./female/head-hair-color/medium_blonde.svg": "9da7",
	"./female/head-hair-color/medium_brown.svg": "d5cb",
	"./female/head-hair-color/red.svg": "6e04",
	"./female/skin-color/black.svg": "ce1b",
	"./female/skin-color/dark_brown.svg": "289d",
	"./female/skin-color/light_brown.svg": "8018",
	"./female/skin-color/medium_brown.svg": "87c0",
	"./female/skin-color/pale_white.svg": "394c",
	"./female/skin-color/very_pale_white.svg": "7d94",
	"./female/skin-color/white.svg": "2b52",
	"./male/eyes-color/black.svg": "481c",
	"./male/eyes-color/blue.svg": "65d3",
	"./male/eyes-color/brown.svg": "254e",
	"./male/eyes-color/green.svg": "53fe",
	"./male/eyes-color/grey.svg": "964e",
	"./male/eyes-color/hazel.svg": "7b9a",
	"./male/head-hair-color/black.svg": "91d0",
	"./male/head-hair-color/dark_blonde.svg": "82b1",
	"./male/head-hair-color/dark_brown.svg": "c741",
	"./male/head-hair-color/light_blonde.svg": "6e60",
	"./male/head-hair-color/light_brown.svg": "2486",
	"./male/head-hair-color/medium_blonde.svg": "60dd",
	"./male/head-hair-color/medium_brown.svg": "1548",
	"./male/head-hair-color/red.svg": "4814",
	"./male/skin-color/black.svg": "e7ee",
	"./male/skin-color/dark_brown.svg": "a9bf",
	"./male/skin-color/light_brown.svg": "3067",
	"./male/skin-color/medium_brown.svg": "477a",
	"./male/skin-color/pale_white.svg": "386c",
	"./male/skin-color/very_pale_white.svg": "9606",
	"./male/skin-color/white.svg": "56c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d289";